import React, {memo, useEffect, useMemo} from "../../../__snowpack__/pkg/react.js";
import {Form, Input, Modal, Select, Tooltip} from "../../../__snowpack__/pkg/antd.js";
import styled from "../../../__snowpack__/pkg/styled-components.js";
const {Option} = Select;
export const AddInputModal = memo((props) => {
  const {formatMessage, unitList} = props;
  const [form] = Form.useForm();
  useEffect(() => {
    if (props.visible) {
      form.setFieldsValue({
        editValue: void 0
      });
    }
  }, [props.visible]);
  const selectAfter = useMemo(() => {
    if (unitList && unitList.length) {
      return /* @__PURE__ */ React.createElement(Form.Item, {
        label: "",
        name: "unitType",
        style: {width: 50},
        rules: [
          {
            message: formatMessage({id: "pleaseEnter"})
          }
        ]
      }, /* @__PURE__ */ React.createElement(Select, {
        defaultValue: unitList[0],
        className: "select-after"
      }, unitList?.map((data) => {
        return /* @__PURE__ */ React.createElement(Option, {
          value: data
        }, /* @__PURE__ */ React.createElement(Tooltip, {
          title: data
        }, data));
      })));
    } else {
      return null;
    }
  }, [unitList]);
  return /* @__PURE__ */ React.createElement(ModalWrapper, {
    title: "  ",
    onOk: async () => {
      try {
        await form.validateFields();
      } catch (error) {
        return;
      }
      const values = form.getFieldsValue();
      let returnVal = values.editValue;
      if (!values.unitType && unitList) {
        returnVal += unitList[0];
      } else {
        returnVal += values.unitType || "";
      }
      props.onChange && props.onChange({value: returnVal});
    },
    onCancel: () => {
      props.onCancel && props.onCancel();
    },
    ...props
  }, /* @__PURE__ */ React.createElement(Form, {
    layout: "vertical",
    form
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    label: formatMessage({id: "sku"}),
    name: "editValue",
    rules: [
      {
        required: true
      },
      {
        max: 50
      }
    ],
    noStyle: true
  }, /* @__PURE__ */ React.createElement(Input, {
    placeholder: formatMessage({
      id: "pleaseEnter"
    }),
    maxLength: 50,
    type: selectAfter ? "number" : "text",
    addonAfter: selectAfter
  }))));
});
const ModalWrapper = styled(Modal)`
  &.edit-price-modal {
  }
  .ant-modal-body {
    margin-bottom: -16px;
  }
  .ant-form-item {
    margin-bottom: 0;
  }
  .ant-input-group .ant-input {
    height: 30px;
  }
  .ant-select-arrow {
    right: 0;
  }
  .ant-select-single.ant-select-show-arrow .ant-select-selection-item,
  .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
    padding-right: 0;
  }
`;
